"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPOSIXTimeRange = void 0;
var PInterval_1 = require("../Interval/PInterval.js");
exports.PPOSIXTimeRange = PInterval_1.PInterval;
